module.exports = __webpack_public_path__ + "img/cara-feliz.710fe009.svg";